import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../../assets/Images/icons/empty';
import { useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const StepList = ({
    setCurrentSelectList,
    currentSelectList,
    SW,
    isNew,
    onSelectTopic,
    data,
    setData,
    errorMode,
    handleError,
    setIsAddingNewTopic,
    validateSequence0,
    validateSequencesGreaterThan0,
    ...props
}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n?.language;

    const addNewTopic = () => {
        const newSequence = data.length;
        const newTopic = {
            isDefault: false,
            sequence: newSequence,
            freeFormPolicyId: '',
            freeFormPolicyNameTh: '',
            freeFormPolicyNameEn: '',
            freeFormCompanyNameTh: '',
            freeFormCompanyNameEn: '',
            freeFormPolicyDataSubjectType: [],
            freeFormTopicDataId: '',
            freeFormTitleTh: 'หัวข้อ...',
            freeFormTitleEn: 'Topic...',
            freeFormContentTh: '',
            freeFormContentEn: '',
            freeFormIsDisplay: true,
        };
        setData([...data, newTopic]);
        setCurrentSelectList(newSequence)
        setIsAddingNewTopic(true);
    };

    const onDragEnd = (result) => {
        const { destination, source } = result;

        if (!destination || destination.index === source.index) {
            return;
        }
        const reorderedData = Array.from(data);
        const [movedItem] = reorderedData.splice(source.index + 1, 1);
        reorderedData.splice(destination.index + 1, 0, movedItem);

        const updatedData = reorderedData.map((item, index) => ({
            ...item,
            sequence: item.isDefault ? 0 : index,
        }));

        setData(updatedData);
    };

    const handleSelectList = (selectedIndex) => {
        setCurrentSelectList(selectedIndex);
        const selectedTopic = data[selectedIndex];
        onSelectTopic(selectedTopic);
        // handleError(selectedIndex, true);

    };

    useEffect(() => {
        handleSelectList(currentSelectList);
    }, [currentSelectList]);

    return (
        <div className="col-span-1">
            <div className="bg-white rounded-md shadow-sm pt-5 pb-5">
                <div
                    style={{
                        borderBottom: '1px solid #ECECEC',
                    }}
                    className="text-xs font-semibold px-5 pb-4 flex justify-between"
                >
                    <p className='mb-0 text-purple-PHX'>{t('Privacy topic')}</p>
                    <p className='mb-0 text-new underline cursor-pointer' onClick={addNewTopic}>
                        + {t('Add topic')}
                    </p>
                </div>

                {data?.[0]?.isDefault && (
                    <div
                        className={`free-form-list pl-0 cursor-pointer w-full bg-white ${currentSelectList === 0 ? 'select' : ''
                            }`}
                        onClick={() => {
                            handleSelectList(0); 
                            validateSequence0(); 
                        }}
                    >
                        <div className="my-2 py-2 pl-4 flex w-full items-center">
                            <div className="flex">
                                <div className="font-semibold text-xs flex justify-between items-center">
                                    {errorMode.includes(0) && (
                                        <svg className='pr-2 w-4' width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="5" cy="5" r="5" fill="#F0536F" />
                                        </svg>
                                    )}

                                    <span>
                                        {lang === 'th'
                                            ? data[0].freeFormTitleTh || '-'
                                            : data[0].freeFormTitleEn || '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="stepList">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {data.slice(1).map((e, i) => (
                                    <Draggable
                                        key={i + 1}
                                        draggableId={String(i + 1)}
                                        index={i}
                                    >
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className={`free-form-list pl-0 cursor-pointer w-full bg-white ${currentSelectList === e.sequence ? 'select' : ''
                                                    }`}
                                                style={{
                                                    ...provided.draggableProps.style
                                                }}
                                                onClick={() => {
                                                    handleSelectList(e?.sequence);
                                                    validateSequencesGreaterThan0(); 
                                                }}
                                            >
                                                <div className="my-2 py-2 px-4 flex w-full items-center">
                                                    <div className="flex-1">
                                                        <div className="font-semibold text-xs flex justify-between items-center">

                                                            <span>
                                                                {errorMode.includes(e?.sequence) && (
                                                                    <svg className='pr-2 w-4' width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="5" cy="5" r="5" fill="#F0536F" />
                                                                    </svg>
                                                                )}
                                                                {lang === 'th'
                                                                    ? e.freeFormTitleTh || '-'
                                                                    : e.freeFormTitleEn || '-'}
                                                            </span>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <rect width="24" height="24" rx="3" fill="#EEE5FF" />
                                                                <g clipPath="url(#clip0_380_13924)">
                                                                    <path d="M17.3334 10H6.66675V11.3333H17.3334V10ZM6.66675 14H17.3334V12.6667H6.66675V14Z" fill="#7B67FB" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_380_13924">
                                                                        <rect width="16" height="16" fill="white" transform="translate(4 4)" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}

                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </div>
    );
};

export default StepList;
